/** 回购 */
<template>
  <div class="home data-panel-home">
    <Header title="兑换申请"></Header>
    <div>
      <!-- 选择要提现的其中一个email -->
      <el-row v-if="balance !== 'NONE'" class="margin-top-20" style="word-wrap: break-word;word-break: break-all;">
        <el-col :span="10" class="select-title"><div class="left-wrap">选择提现账号</div></el-col>
        <el-col :span="14" class="padding-left-20">
          <el-select class="commit_channel" v-model="selectEmail" placeholder="请选择"  @change="changeSelectEmail">
            <el-option
            v-for="item in emailList"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
          </el-select>
        </el-col> 
      </el-row>
       <!-- 兑换面额选择 -->
       <el-row v-if="balance !== 'NONE'" class="margin-top-20" style="word-wrap: break-word;word-break: break-all;">
         <el-col :span="10" class="select-title"><div class="left-wrap">请选择兑换面额</div></el-col>
         <el-col :span="14" class="padding-left-20">
         <el-select class="commit_channel" v-model="JDCardMoney" placeholder="请选择" @change="queryLimit">
           <el-option
           v-for="item in canExchangeMoney"
           :key="item"
           :label='item + "元"'
           :value="item"
           >
           </el-option>
         </el-select>
         <!-- <span v-if="!exchangeStatus" class="exchange-tips bonus-tips">今日兑换额度已用完</span> -->
         </el-col> 
       </el-row>
       <!-- 兑换张数 -->
       <el-row class="margin-top-20" style="word-wrap: break-word;word-break: break-all;">
         <el-col :span="10" class="select-title"><div class="left-wrap">请选择兑换张数</div></el-col>
         <el-col :span="14" class="padding-left-20">
         <el-select class="commit_channel" v-model="JDCardCount" placeholder="请选择">
           <el-option
           v-for="item in exchangeCountList"
           :key="item"
           :label='item + "张"'
           :value="item"
           >
           </el-option>
         </el-select>
         </el-col> 
       </el-row>
       <!-- 要兑换的JD卡总额为 -->
       <el-row class="margin-top-20" style="word-wrap: break-word;word-break: break-all;">
         <el-col :span="10"><div class="left-wrap" >要兑换的JD卡总额</div></el-col>
         <el-col :span="14" class="right-wrap padding-left-20">
           <div v-if="exchangeJDMoney !== 'OVER_AMMOUNT'">{{exchangeJDMoney ? (exchangeJDMoney + '元') : '-'}}</div>
           <div
             class="bonus-tips"
             v-if="exchangeJDMoney === 'OVER_AMMOUNT'"
           >兑换张数超出额度</div>
         </el-col>
       </el-row>
       <!-- 当前BP兑换价 -->
       <el-row>
         <el-col :span="10"><div class="left-wrap"><div>当前BP兑换价</div></div></el-col>
         <el-col :span="14" class=" right-wrap padding-left-20"><div>{{RMBPrice + ' 元' || '-'}}</div></el-col>
       </el-row>
       <!-- 需要BP数量 -->
       <el-row>
         <el-col :span="10"><div class="left-wrap">需要BP数量</div></el-col>
         <el-col
           :span="14"
           class=" right-wrap padding-left-20"
         ><div>{{needBXCCount ? (needBXCCount + ' BP') : '-'}}</div></el-col>
       </el-row>
       <!-- 账户余额 -->
       <el-row>
         <el-col :span="10">
           <div class="left-wrap">账户余额
           </div>
         </el-col>
         <el-col
           :span="14"
           class="padding-left-20"
         >
           <div>{{balance + ' BP' || '-'}}</div>
         </el-col>
       </el-row>
       <!-- 验证码 -->
       <el-row v-if="balance !== 'NONE'">
         <el-col :span="10" class="select-title"><div class="left-wrap">输入手机验证码</div></el-col>
         <el-col
           :span="14"
           class="padding-left-20"
         >             
           <SendVerifyCode
             :iconType="noIcon"
             type="text"
             icon-type="emailCode"
             @verifyCodeTip="verifyCodeTip"
             v-model="inputEmailCode"
             :tel="tel"
           />
         </el-col>
       </el-row>
     <div v-if="balance !== 'NONE'" class="buttonWrap_wechat">
       <div class="button " @click="commit">确认</div>
       <div class="button" style="margin-top: 10px;"><a href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx95ccc89810c1da7f&redirect_uri=https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fexchangeList&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect" style="color: #fff;">兑换记录</a></div>
       <!-- <div class="button" style="margin-top: 10px;">
         <a style="color: #fff;" href="http://127.0.0.1:8080/wechat/exchangeList?code=0911RnGa1ou26C0EiwJa1oAdU311RnGs&state=123">兑换记录</a>
        </div> -->
       
     </div>
   </div>
  </div>
</template>

<script>
import Header from "@/WechatComponents/Header.vue";
import SendVerifyCode from "@/components/Common/SendCodeNoTel.vue";
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import { getCookie } from "@/utils/utils";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";

export default {
  name: "AccountLayout",
  props: {},
  components: {
    Header,
    SendVerifyCode
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    email: state => state.account.email,
    balance: state => state.exchange.balance,
    // 当前BP兑换价
    RMBPrice: state => state.exchange.RMBPrice,
    // 可选兑换面额
    canExchangeCount: state => state.exchange.canExchangeCount,
    // 可选兑换张数list
    canExchangeMoney: state => state.exchange.canExchangeMoney,
    // 计算可选兑换张数
    exchangeCountList() {
      let { JDCardMoney, canExchangeCount } = this;

      if (JDCardMoney && canExchangeCount[JDCardMoney]) {
        return canExchangeCount[JDCardMoney];
      } else {
        return [];
      }
    },
    //要兑换的JD卡总额
    exchangeJDMoney() {
      let { JDCardCount, JDCardMoney, balance, RMBPrice } = this;
      let money = JDCardCount * JDCardMoney;

      if (money > balance * RMBPrice) {
        return "OVER_AMMOUNT";
      } else {
        return money;
      }
    },
    // 需要BP数量
    needBXCCount() {
      let { exchangeJDMoney, balance, RMBPrice } = this;

      if (exchangeJDMoney && exchangeJDMoney !== "OVER_AMMOUNT") {
        return Math.ceil(exchangeJDMoney / RMBPrice);
      } else {
        return "";
      }
    }
  }),
  data() {
    return {
      exchangeStatus: true, //兑换状态
      exchangeCount: "", //兑换张数
      inputEmailCode: "",
      JDCardMoney: "",// 选中京东面额
      JDCardCount: "",// 选中京东数额
      noIcon:false,
      tel:'',//发送验证码的手机号
      selectEmail:'',//选择提现的邮箱
      emailList:[],//绑定的邮箱list
    };
  },
  async created() {
    try {
      let openid = getCookie("openid") || this.$route.query.openid;
      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fexchange";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;
  
      if (openid || code) {
        this.openId = openid;
        this.getWechatInfo({ openid, code }).then(res=>{
          this.emailList = res.emails;
        })
      } else {
        // window.location.href = "http://127.0.0.1:8080/wechat/exchange?code=051jslGa1e89uD0UAlGa1x2l3B4jslGS&state=123"
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions([
      "getWechatInfo",//获取微信用户信息
      "getWechatTelFromEmail",//根据openid获取email tel
      "getWechatExchangeInfo",//获取JD卡面额 张数
      "setWechatCommitExchange",//发起JD卡兑换
      "getExchangeList",
      "getLimitExchange"
    ]),
    //选择提现的邮箱
    changeSelectEmail(val){
      this.JDCardMoney = '';
      this.JDCardCount = '';
      let email = val;
      this.getWechatTelFromEmail({ email }).then(res=>{
        this.tel = res.tel;
        let id = res.id;
        this.getWechatExchangeInfo({ id,email  }).then(res1=>{
          if(res1 && res1.message){
            this.$store.commit('claerBalance')
            Message({
              message:res1.message,
              type:'error'
            })
          }
        })
      })
    },
    // 查询限额
    queryLimit() {
      let { JDCardMoney } = this;

      this.getLimitExchange({ JDCardMoney }).then(res => {
        if (res.code !== 200) {
          this.exchangeStatus = false;
        } else {
          this.exchangeStatus = true;
        }
      });

      console.log(JDCardMoney);
    },
    //提交兑换
    commit() {
      let {
        inputEmailCode,
        JDCardMoney,
        JDCardCount,
        exchangeJDMoney,
        needBXCCount,
        RMBPrice,
        tel
      } = this;
      
      if(!this.selectEmail){
        Message({
          message:"请选择要申请兑换的账号",
          type:"error",
        })
        return false;
      }

      if (!inputEmailCode) {
        Message({
          type: "error",
          message: "缺少手机验证码" || "network error"
        });
      } else if (!JDCardMoney || !JDCardCount) {
        Message.error('请选择兑换面额或者兑换张数');
      } else {
        // this.$confirm(
        //   `您确定要使用 ${needBXCCount} BP 兑换 ${JDCardCount} 张 面额为 ${JDCardMoney}元的 JD卡吗？`,
        //   {
        //     confirmButtonText: '确认',
        //     cancelButtonText: '取消'
        //   }
        // )
        this.$confirm(`您确定要使用 ${needBXCCount} BP 兑换 ${JDCardCount} 张 面额为 ${JDCardMoney}元的 JD卡吗？`, '提示', {
          customClass: 'message-logout'
        }).then(() => {
          this.setWechatCommitExchange({
            JDCardMoney,
            JDCardCount,
            exchangeJDMoney,
            needBXCCount,
            RMBPrice,
            emailVerifyCode: inputEmailCode,
            tel
          }).then(res => {
            console.log(res);
            if (res.code === 200) {
              Message({
                type: "success",
                message: "提交成功，等待处理"
              });
              this.selectEmail = '';
              this.JDCardCount = '';
              this.JDCardMoney = '';
              this.$store.commit('claerBalance')
              // this.getExchangeList();
            } else {
              Message({
                type: "error",
                message: res.message || "network error"
              });
            }
          });
        });
      }
    },
    //手机验证
    verifyCodeTip(error) {
      if (error && error.message) {
        Message({
          message: error.message,
          type: "error",
        });
      }
    },
  }
};
</script>

<style  lang="stylus" scoped="scoped">
  .buttonWrap_wechat{
    display:flex;
    -webkit-box-pack:center;
    justify-content:center;
    margin:30px;
    margin-bottom: 80px;
  }
  .select-title{
    line-height: 38px;
  }
  .commit_channel{
    margin:0 !important;
  }
  *{
    touch-action:none;
    touch-action:pan-y;
  }
  .exchange-tips{
    font-size: 12px;
    margin-left: 20px;
  }
  
  .el-row{
    width:100%;
    padding: 8px 15px;
  }
  .data-panel-home.home {
    height: auto !important;
  }

  .addr-status {
    margin: 40px;
    color: #909399;
  }

  .last-price-key {
    margin: 10px 0;
  }
  
  .commit-wrap{
    .left-wrap {
      width: 100%;
      color: #96999b;
      text-align: right;
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      margin: 10px 0;
    }
  
  .ZFB_info{
    font-size:18px;
    line-height:50px;
    color:black;
    text-align:center;
  }
	
  .item {
    padding: 18px 0;
  }
	
  .el-card__body{
    padding:20px 0;
  }
	
  .linkto_MyWallet{
    color:#f56c6c;
  }
	
  .box-card {
    width: 400px;
    margin:80px 37%;
    background-color:white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border-radius:2px;
    display:flex;
  }

  .right-wrap {
    margin: 10px 0;
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }

  .right-input {
    width: 230px;
    height: 40px;
    margin: 15px 0;
  }

  .captcha-wrap {
    margin: 15px 0;
  }

  .real-money {
    line-height: 30px;
  }
 }
</style>
<style>
  .message-logout {
    width: 80% !important;
  }
</style>

